import { Injectable } from '@angular/core';

const STORAGE_KEY = 'colorScheme';
const DARK_CLASS = 'app-dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  isDarkMode = false;

  // Called once at bootstrap, before the first paint, so the theme is
  // already correct on load instead of flashing light-then-dark. Defaults
  // to light mode until the user explicitly toggles it, regardless of the
  // system/browser color-scheme preference.
  init(): void {
    const stored = localStorage.getItem(STORAGE_KEY);
    this.setDarkMode(stored === 'dark');
  }

  toggleDarkMode(): void {
    this.setDarkMode(!this.isDarkMode);
  }

  private setDarkMode(dark: boolean): void {
    this.isDarkMode = dark;
    document.documentElement.classList.toggle(DARK_CLASS, dark);
    localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
  }
}
